'use client'

import { useState, useEffect } from 'react'

export function useTelegramWebApp() {
  const [isWebApp, setIsWebApp] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }

    if (window.Telegram?.WebApp) {
      setIsWebApp(true)
      return
    }

    const checkWebApp = () => {
      if (window.Telegram?.WebApp) {
        setIsWebApp(true)
      }
    }

    const interval = setInterval(checkWebApp, 100)

    const timeout = setTimeout(() => {
      clearInterval(interval)
    }, 5000)

    return () => {
      clearInterval(interval)
      clearTimeout(timeout)
    }
  }, [])

  return isWebApp
} 